<template>
	<div class="order-msg-page">
		
		<!-- 面包屑导航 -->
		<div class="breadcrumb animate__animated  ">
			<div class="breadcrumb-inner">
				<span class="crumb-label">当前位置：</span>
				<span class="crumb-home">代购订单</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/30868_6903/9.svg')"></el-image>
				<span class="crumb-current">查看详情</span>
			</div>
			<div class="back-btn" @click="$router.back()">
				<span>返回</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/10.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 主内容区（flex 行布局） ===== -->
		<div class="content-row animate__animated  ">
			
			<!-- 左侧：订单信息卡片 -->
			<div class="order-card">
				
				<!-- 蓝色状态头 -->
				<div class="order-header" v-if="orderMsg.orderStatus==0">
					<el-image class="header-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/32.svg')"></el-image>
					<span class="header-text">待付款，剩余支付时间{{ obj.minutes }}:{{ obj.seconds }}</span>
				</div>
				
				<div class="order-header" v-if="orderMsg.orderStatus==1">
					<el-image class="header-icon" :src="require('@/static/add2/49.png')"></el-image>
					<span class="header-text">已付款，您的商品正在打包中 请耐心等候</span>
				</div>
				
				 <!--  -->
				<div class="order-header" v-if="orderMsg.orderStatus==2">
					<el-image class="header-icon" :src="require('@/static/add2/50.png')"></el-image>
					<span class="header-text">采购中，您的商品正在采购中 请耐心等候</span>
				</div>
				
				<div class="order-header" v-if="orderMsg.orderStatus==3">
					<el-image class="header-icon" :src="require('@/static/add2/50.png')"></el-image>
					<span class="header-text">已采购，您的商品已采购 请耐心等候</span>
				</div>
				
				<div class="order-header" v-if="orderMsg.orderStatus==4">
					<el-image class="header-icon" :src="require('@/static/add2/53.png')"></el-image>
					<span class="header-text">已完成，您的订单已完成 期待再次为您服务</span>
				</div>
				
				<div class="order-header" v-if="orderMsg.orderStatus==5">
					<el-image class="header-icon" :src="require('@/static/add2/52.png')"></el-image>
					<span class="header-text">已售后，您的订单交易失败 已关闭</span>
				</div>
				
				<div class="order-header" v-if="orderMsg.orderStatus==-1">
					<el-image class="header-icon" :src="require('@/static/add2/52.png')"></el-image>
					<span class="header-text">已取消，您的订单交易失败 已关闭</span>
				</div>

				<!-- 收件地址区域 -->
				<div class="section-block" v-if="memberAddress">
					<div class="section-title">
						<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/27.svg')"></el-image>
						<span class="title-text">收件地址</span>
					</div>
					<div class="address-card">
						<div class="address-name-row">
							<el-image class="name-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/26.svg')"></el-image>
							<span class="addr-name">{{memberAddress.consignee}}</span>
							<span class="addr-phone">{{memberAddress.mobile}}</span>
						</div>
						<div class="address-detail-row">
							<span class="addr-country">{{memberAddress.countryName}}</span>
							<span class="addr-street">{{memberAddress.provinceName}}{{memberAddress.cityName}}{{memberAddress.address}}</span>
						</div>
					</div>
				</div>

				<!-- 订单信息区域 -->
				<div class="section-block order-section">
					
					<template v-if="deliveryList.length">
						
					<div class="section-title">
						<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/31.svg')"></el-image>
						<span class="title-text">物流信息</span>
					</div>
					
					<!-- 物流列表 -->
					<div class="wuliuList f-ct">
						<div class="wlItem" v-for="(item,index) in deliveryList">
							<div class="t1 f-bct">
								<div>物流公司：{{item.companyName}}</div>
								<div class="look" @click="openWlDialog(item)">查看物流</div>
							</div>
							<div class="t2 f-ct">
								<div>物流单号：{{item.deliveryNo}}</div>
								<el-image :src="require('@/static/add2/51.png')" class="copy-icon" @click="copy_txt(orderMsg.deliveryNo)"></el-image>
							</div>
						</div>
					</div>
					
					</template>
					
					<div class="section-title">
						<el-image class="title-icon" :src="require('@/static/CodeBuddyAssets/30868_6903/31.svg')"></el-image>
						<span class="title-text">订单信息</span>
					</div>
					
					<!-- 电商单号 -->
					<div class="dianshangO" v-if="orderMsg.platformNo">
						<div class="t1">电商编号：{{orderMsg.platformNo||'暂无'}}</div>
						<el-image :src="require('@/static/add2/51.png')" class="copy-icon" @click="copy_txt(orderMsg.platformNo)"></el-image>
					</div>
					
					<div class="order-item-card" v-for="(gitm,gidx) in shopGroups">
						<div class="item-header-row">
							<div class="shop-tag1" v-if="gitm.channelType==1">
								<span class="tag-text">自营</span>
							</div>
							<div class="shop-tag" v-if="gitm.channelType==2">
								<span class="tag-text">1688</span>
							</div>
							<div class="shop-tag2" v-if="gitm.channelType==3">
								<span class="tag-text">淘宝</span>
							</div>
							<div class="shop-tag" v-if="gitm.channelType==4">
								<span class="tag-text">京东</span>
							</div>
							<el-image class="shop-avatar" :src="require('@/static/CodeBuddyAssets/30868_6903/29.svg')"></el-image>
							<span class="shop-name">{{gitm.merchantName}}</span>
						</div>
						<div class="item-body-row" v-for="(item,index) in gitm.goodsList">
							<el-image class="item-img" :src="item.picUrl" :preview-src-list="[item.picUrl]" fit="cover"></el-image>
							<div class="item-info">
								<p class="item-name">{{item.goodsName}}</p>
								<p class="item-spec">{{item.specifications.join(' ')}}</p>
							</div>
							<template v-if="peizhiMsg.isOpenRefund*1">
							<div class="goreturn" @click="link('/userPageLab/myShopOrderReturn',{id:item.id,orderStatus:orderMsg.orderStatus})" v-if="item.rightStatus==1">申请售后</div>
							<div class="goreturn" style="color: #0096FF;border-color: #0096FF;" v-if="item.rightStatus==2">售后中...</div>
							<div class="goreturn" style="color: #0096FF;border-color: #0096FF;" v-if="item.rightStatus==3">已售后</div>
							<div class="goreturn" v-if="item.rightStatus==4">售后已关闭</div>
							</template>
							<div>
								<div class="item-qty">数量：{{item.number}}</div>
								<div class="item-price">
									<span class="price-symbol">￥</span>
									<span class="price-number">{{item.price}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 底部按钮 -->
				<div class="card-actions" v-if="orderMsg.orderStatus==0">
					<div class="action-btn btn-cancel" @click="deleteOrder()">取消订单</div>
					<div class="action-btn btn-pay" @click="link('/userPageLab/myShopPay',{id:id})">去支付</div>
				</div>
			</div>

			<!-- 右侧：付款详情 -->
			<div class="payment-panel">
				<div class="panel-title">订单信息</div>
				<div class="fee-row">
					<span class="fee-label">仓库</span>
					<span class="fee-value">{{orderMsg.warehouseName}}</span>
				</div>
				<div class="fee-row" v-if="memberAddress">
					<span class="fee-label">物流方案</span>
					<span class="fee-value">{{orderMsg.transportLinesName}}</span>
				</div>
				<div class="panel-title">付款详情</div>
				<div class="fee-row">
					<span class="fee-label">商品总价</span>
					<span class="fee-value">￥{{orderMsg.goodsPrice}}</span>
				</div>
				<div class="fee-row">
					<span class="fee-label">国内运费</span>
					<span class="fee-value">￥{{orderMsg.domesticFreightPrice}}</span>
				</div>
				<div class="fee-row">
					<span class="fee-label">代购服务费</span>
					<span class="fee-value">￥{{orderMsg.daigouPrice}}</span>
				</div>
				<div class="fee-row fee-row-coupon">
					<span class="fee-label">优惠券</span>
					<span class="fee-value fee-discount">
						<span class="discount-text">优惠</span>
						<span class="discount-amount">-￥{{orderMsg.couponPrice}}</span>
					</span>
					<el-image class="coupon-arrow" :src="require('@/static/CodeBuddyAssets/30868_6903/28.svg')"></el-image>
				</div>
				<div class="fee-row fee-row-coupon">
					<span class="fee-label">运费优惠券</span>
					<span class="fee-value fee-discount">
						<span class="discount-text">优惠</span>
						<span class="discount-amount">-￥{{orderMsg.freightCouponPrice}}</span>
					</span>
					<el-image class="coupon-arrow" :src="require('@/static/CodeBuddyAssets/30868_6903/28.svg')"></el-image>
				</div>
				<div class="fee-row fee-row-remark">
					<span class="fee-label">备注</span>
					<span class="fee-value fee-placeholder">{{orderMsg.remark||'暂无'}}</span>
				</div>
				<div class="total-row">
					<span class="total-label">总计：</span>
					<span class="total-symbol">￥</span>
					<span class="total-number">{{orderMsg.actualPrice}}</span>
				</div>
				<div class="fee-divider"></div>
				<div class="info-row">
					<span class="info-label">订单编号</span>
					<span class="info-code">{{orderMsg.orderNo}}</span>
					<span class="info-copy" @click="copy_txt(orderMsg.orderNo)" style="color: #0096FF;">复制</span>
				</div>
				<div class="info-row">
					<span class="info-label">创建时间</span>
					<span class="info-date">{{orderMsg.createTime}}</span>
				</div>
				<div class="info-row" v-if="orderMsg.payTime">
					<span class="info-label">付款时间</span>
					<span class="info-date">{{orderMsg.payTime}}</span>
				</div>
				<div class="info-row" v-if="orderMsg.purchaseTime">
					<span class="info-label">采购时间</span>
					<span class="info-date">{{orderMsg.purchaseTime}}</span>
				</div>
				<div class="info-row" v-if="orderMsg.orderStatus==4">
					<span class="info-label">完成时间</span>
					<span class="info-date">{{orderMsg.updateTime}}</span>
				</div>
				<div class="info-row" v-if="orderMsg.cancelTime==4">
					<span class="info-label">关闭时间</span>
					<span class="info-date">{{orderMsg.cancelTime}}</span>
				</div>
			</div>
		</div>
		
		<!-- ===== 取消订单弹出框 ===== -->
		<el-dialog
			:visible.sync="addMarkVisibleDel"
			width="464px"
			custom-class="add-mark-dialog"
			:show-close="false"
			:close-on-click-modal="false">
			<!-- 自定义头部 -->
			<div slot="title" class="dialog-header">
				<h2 class="dialog-title">取消订单</h2>
				<el-image class="dialog-close-icon" :src="require('@/static/sel/20.svg')" @click="addMarkVisibleDel = false"></el-image>
			</div>
			<div class="dialog-title1">
				确定取消该订单吗？
			</div>
			<!-- 底部按钮区 -->
			<div slot="footer" class="dialog-footer">
				<button class="btn-cancelcc" @click="addMarkVisibleDel = false">{{$t('olist.hb5')}}</button>
				<button class="btn-confirmcc" @click="transportOrderremoveByIdF">确定取消</button>
			</div>
		</el-dialog>
		
		
		<!-- ===== 物流信息弹出框 ===== -->
		<el-dialog
			:visible.sync="wlDialogVisible"
			width="8rem"
			custom-class="wl-popup"
			:show-close="false"
			:close-on-click-modal="true">
			<div slot="title" class="popup-header">
				<h3 class="popup-title">物流信息</h3>
			</div>
			<div class="submitPopup">
				<div class="wlsn f-bct">
					<div class="t1">{{wlMsgAll.companyName}}&emsp;{{wlMsgAll.deliveryNo}}<span @click="copy_txt(wlMsgAll.deliveryNo)">复制</span></div>
				</div>
				<div class="wuliuListHb">
					<div class="item" v-for="(item,index) in logisticsJson.traces">
						<div class="txtbox">
							<span class="t1">{{item.acceptStation}}</span>
							<span class="t2">{{item.acceptTime}}</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="popup-footer">
				<div class="popup-btn btn-confirm" @click="confirmWlDialog">返回</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import {
	configbase,
	orderdetail,
	ordercancel,
} from "/src/api/api.js"
let iv;
export default {
	name: 'MyShopOrderMsg',
	data() {
		return {
			peizhiMsg:'',
			id:0,
			orderMsg:'',
			shopGroups:'',
			memberAddress:'',
			deliveryList:[],
			deliveryListSn:[],
			orderPastTime:'',
			obj:'',
			addMarkVisibleDel:false,
			// 物流弹出框
			wlDialogVisible:false,
			wlMsgAll:'',
			logisticsJson:'',
		}
	},
	mounted() {
		if(this.$route.query.id){
			this.id = this.$route.query.id*1
		}
		this.configbase()
	},
	methods: {
		// 物流弹出框
		openWlDialog(wlMsg){
			this.wlMsgAll = wlMsg
			var logisticsJson = JSON.parse(wlMsg.logisticsJson)
			this.logisticsJson = logisticsJson
			this.wlDialogVisible = true
		},
		confirmWlDialog() {
			this.wlDialogVisible = false
		},
		// 基本配置
		async configbase(){
			const res = await configbase({})
			if(res.code==200){
				this.peizhiMsg = res.data
				this.orderPastTime = res.data.orderPastTime
				// 订单支付详情
				this.getorderdetail()
			}else{this.Tips(res.msg,'error')}
		},
		// 订单详情
		async getorderdetail(){
			const res = await orderdetail({orderPayId:this.id})
			if(res.code==200){
				this.shopGroups = res.data.shopGroups
				this.memberAddress = res.data.memberAddress
				this.deliveryList = res.data.deliveryList
				var deliveryListSn = []
				this.deliveryList.forEach((item)=>{
					if(item.isNeedLogistics){
						deliveryListSn.push(item.deliveryNo)
					}
				})
				this.deliveryListSn = deliveryListSn
				this.orderMsg = res.data
				if(this.orderMsg.orderStatus==0){
					this.obj = this.getTimeLeft(res.data.createTime,this.orderPastTime)
					iv = setInterval(()=>{
						this.obj = this.getTimeLeft(res.data.createTime,this.orderPastTime)
					},1000)
				}
			}else{this.Tips(res.msg,'error')}
		},
		// 取消按钮
		deleteOrder() {
			this.addMarkVisibleDel = true
		},
		async transportOrderremoveByIdF(){
			var res;
			res = await ordercancel({
				orderId:this.id,
			});
			if(res.code==200){
				this.addMarkVisibleDel = false
				this.Tips(res.msg)
				this.getorderdetail()
			}else{this.Tips(res.msg,'error')}
		},
		//取倒计时（天时分秒）
		getTimeLeft(datetimeTo,fen){
			// 计算目标与现在时间差（毫秒） 时间格式  2021-10-14 00:00:00   
			// ios需转换格式为  2021/10/14 00:00:00
			// ios时间兼容格式转换
			datetimeTo = datetimeTo.replace(new RegExp('-', 'g'), '/');
			// 时间转时间搓
			let time1 = new Date(datetimeTo).getTime();
			let time2 = new Date().getTime();
			if(fen){
				time1 = time1+fen*60000
			}
			let mss = time1 - time2;
			// 倒计时结束
			if (mss < 0) {
				var obj = {
					days: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
				}
				return obj
			}
			// 将时间差（毫秒）格式为：天时分秒
			let days = parseInt(mss / (1000 * 60 * 60 * 24));
			let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = parseInt((mss % (1000 * 60)) / 1000);
			if(days<10){
				days = '0'+days
			}
			if(hours<10){
				hours = '0'+hours
			}
			if(minutes<10){
				minutes = '0'+minutes
			}
			if(seconds<10){
				seconds = '0'+seconds
			}
			var obj = {
				days: days,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
			}
			return obj
		},
	},
	beforeDestroy(){
		clearInterval(iv);
	},
}
</script>

<style lang="scss" scoped>
.order-msg-page {
	width: 100%;
	box-sizing: border-box;
}

/* ===================================================================
   面包屑导航
   =================================================================== */
.breadcrumb {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 22px;
	margin-bottom: 24px;
	margin-top: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 16px;
	color: #333;
	font-weight: 400;
}
.crumb-home {
	font-size: 16px;
	color: #666;
	font-weight: 400;
}
.crumb-sep {
	width: 14px;
	height: 14px;
	margin: 0 8px;
	flex-shrink: 0;
}
.crumb-current {
	font-size: 16px;
	color: #0096FF;
	font-weight: 400;
}
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	span {
		font-size: 16px;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 14px;
		height: 14px;
		margin-left: 6px;
	}
}

/* ===================================================================
   主内容行（flex 行布局）
   =================================================================== */
.content-row {
	display: flex;
	align-items: flex-start;
}

/* ===================================================================
   左侧：订单信息卡片（1232px）
   =================================================================== */
.order-card {
	width: 1232px;
	background: #fff;
	border-radius: 12px;
	box-sizing: border-box;
	overflow: hidden;
	position: relative;
	flex-shrink: 0;
}

/* ---- 蓝色状态头 (80px) ---- */
.order-header {
	height: 80px;
	background: #0096FF;
	display: flex;
	align-items: center;
	padding-left: 32px;
	box-sizing: border-box;
}
.header-icon {
	width: 32px;
	height: 32px;
	flex-shrink: 0;
}
.header-text {
	font-size: 20px;
	font-weight: 500;
	color: #fff;
	margin-left: 12px;
}

/* ---- 通用区块 ---- */
.section-block {
	padding: 20px 24px 0;
	box-sizing: border-box;
	padding-top: 28px;
	// padding-bottom: 24px;
}
.section-title {
	display: flex;
	align-items: center;
	height: 28px;
	margin-bottom: 16px;
}
.title-icon {
	width: 8px;
	height: 18px;
	flex-shrink: 0;
}
.title-text {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin-left: 4px;
}

/* ---- 收件地址卡片 (1184px) ---- */
.address-card {
	width: 1184px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding: 16px;
	box-sizing: border-box;
}
.address-name-row {
	display: flex;
	align-items: center;
	height: 22px;
	margin-bottom: 12px;
}
.name-icon {
	width: 22px;
	height: 22px;
	flex-shrink: 0;
}
.addr-name {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 10px;
}
.addr-phone {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}
.address-detail-row {
	display: flex;
	align-items: center;
	height: 20px;
}
.addr-country {
	font-size: 14px;
	color: #0096FF;
	font-weight: 400;
}
.addr-street {
	font-size: 14px;
	color: #999;
	font-weight: 400;
	margin-left: 8px;
}

/* ---- 订单信息区块 ---- */
.order-section {
	padding-bottom: 24px;
}

.order-item-card {
	width: 1184px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 6px;
	box-sizing: border-box;
}
.item-header-row {
	display: flex;
	align-items: center;
	height: 39px;
	background: #F8F8F8;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	padding: 0 16px;
	box-sizing: border-box;
}
.shop-tag {
	// width: 31px;
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #FFE9E9;
	border: 1px solid #FC3C3C;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #FC3C3C;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}
.shop-tag1 {
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #E9F5FF;
	border: 1px solid #0096FF;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #0096FF;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}
.shop-tag2 {
	// width: 31px;
	height: 16px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	background: #FFF5E9;
	border: 1px solid #FF7120;
	padding: 0 4px;
	border-radius: 2px;
	.tag-text {
		font-size: 10px;
		color: #FF7120;
		font-weight: 400;
		z-index: 1;
		position: relative;
	}
}

.shop-avatar {
	width: 18px;
	height: 18px;
	margin-left: 6px;
	flex-shrink: 0;
}
.shop-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}

.item-body-row {
	display: flex;
	align-items: center;
	padding: 20px 24px;
	box-sizing: border-box;
}
.item-img {
	width: 68px;
	height: 68px;
	border-radius: 6px;
	flex-shrink: 0;
	cursor: pointer;
}
.item-info {
	margin-left: 12px;
	flex: 1;
}
.item-name {
	font-size: 14px;
	font-weight: 500;
	color: #333;
	margin: 0 0 8px;
	line-height: 1.4;
}
.item-spec {
	font-size: 14px;
	color: #7A7A7A;
	font-weight: 400;
	margin: 0;
}
.goreturn{
	width: 100px;
	height: 38px;
	margin-right: 32px;
	border: 1px solid #D0D0D0;
	font-size: 14px;
	color: #2C2C2C;
	border-radius: 6px;
	text-align: center;
	line-height: 36px;
	cursor: pointer;
}
.item-qty {
	font-size: 14px;
	font-weight: 500;
	color: #666;
	flex-shrink: 0;
	margin-bottom: 10px;
	text-align: right;
}
.item-price {
	flex-shrink: 0;
}
.price-symbol {
	font-size: 12px;
	font-weight: 500;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}
.price-number {
	font-size: 20px;
	font-weight: 600;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}

/* ---- 底部操作按钮 ---- */
.card-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 26px 24px 24px;
	box-sizing: border-box;
	padding-top: 10px;
}
.action-btn {
	width: 184px;
	height: 60px;
	border-radius: 10px;
	text-align: center;
	line-height: 60px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	box-sizing: border-box;
	transition: background 0.3s, opacity 0.3s;
}
.btn-cancel {
	border: 2px solid #0096FF;
	color: #0096FF;
	background: #fff;
	margin-right: 24px;
	&:hover {
		background: #F0F8FF;
	}
}
.btn-pay {
	background: #0096FF;
	color: #fff;
	&:hover {
		background: #33ABFF;
	}
}

/* ===================================================================
   右侧：付款详情面板（340px）
   =================================================================== */
.payment-panel {
	width: 340px;
	background: #fff;
	border-radius: 8px;
	padding: 20px;
	box-sizing: border-box;
	margin-left: 24px;
	flex-shrink: 0;
	padding-bottom: 1px;
}
.panel-title {
	font-size: 15px;
	font-weight: 500;
	color: #0096FF;
	margin-bottom: 18px;
}

/* 费用行 */
.fee-row {
	display: flex;
	align-items: center;
	height: 20px;
	margin-bottom: 12px;
}
.fee-label {
	font-size: 14px;
	color: #333;
	font-weight: 400;
}
.fee-value {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	margin-left: auto;
}
.fee-row-coupon {
	position: relative;
}
.fee-discount {
	display: flex;
	align-items: center;
}
.discount-text {
	font-size: 14px;
	color: #333;
	font-weight: 400;
}
.discount-amount {
	font-size: 14px;
	color: #FC3C3C;
	font-weight: 400;
	margin-left: 4px;
}
.coupon-arrow {
	width: 8px;
	height: 8px;
	position: absolute;
	right: 0;
	top: 6px;
}
.fee-placeholder {
	color: #999;
}

.fee-divider {
	width: 300px;
	height: 0.5px;
	background: #F3F3F3;
	margin: 0 0 16px;
}

/* 信息行 */
.info-row {
	display: flex;
	align-items: center;
	height: 20px;
	margin-bottom: 12px;
}
.info-label {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	flex-shrink: 0;
	margin-right: 8px;
}
.info-code {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	margin-right: 6px;
}
.info-copy {
	font-size: 14px;
	color: #333;
	font-weight: 400;
	cursor: pointer;
}
.info-date {
	font-size: 14px;
	color: #333;
	font-weight: 400;
}

/* 总计 */
.total-row {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 16px;
	margin-bottom: 12px;
}
.total-label {
	font-size: 14px;
	font-weight: 500;
	color: #333;
}
.total-symbol {
	font-size: 12px;
	font-weight: 500;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
	margin-left: 4px;
}
.total-number {
	font-size: 20px;
	font-weight: 600;
	color: #FC3C3C;
	font-family: 'MiSans', sans-serif;
}
/* ================================================================
   添加唛头弹窗样式
   ================================================================ */

::v-deep .add-mark-dialog {
	border-radius: 8px;
	overflow: hidden;

	.el-dialog__header {
		padding: 0;
		margin: 0;
	}

	.el-dialog__body {
		padding: 30px 32px 20px;
		padding-bottom: 32px;
	}

	.el-dialog__footer {
		padding: 0 32px 28px;
	}
}


/* ---- 弹窗头部 ---- */
.dialog-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 69px;
	background: #f7fafc;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
	box-sizing: border-box;
}

.dialog-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
}

.dialog-title1 {
	font-family: 'PingFang SC', sans-serif;
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	line-height: 1;
	text-align: center;
}

.dialog-close-icon {
	width: 16px;
	height: 16px;
	cursor: pointer;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.7;
	}
}


/* ---- 弹窗内容区 ---- */
.dialog-body {
	display: flex;
	flex-direction: column;
}


/* 表单字段行 */
.form-field {
	display: flex;
	align-items: center;
	margin: auto;
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 0;
	}
}


/* 字段标签 */
.field-label {
	width: 80px;
	text-align: right;
	font-size: 16px;
	font-weight: 400;
	color: #9A9DA7;
	flex-shrink: 0;
	line-height: 45px;
	margin-right: 14px;

	&--center {
		text-align: center;
	}
}


/* 输入框 */
.field-input {
	width: 307px;
	
	.el-input__inner {
		height: 41px;
		line-height: 41px;
		border: 2px solid #E8EDF4;
		border-radius: 8px;
		font-size: 16px;
		color: #333333;
		padding: 0 16px;

		&::placeholder {
			color: #999999;
		}

		&:focus {
			border-color: #0096FF;
		}
	}
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 4px;
}


/* 返回按钮 */
.btn-cancelcc {
	width: 120px;
	height: 44px;
	background: #E9F6FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}

/* 确认修改按钮 */
.btn-confirmcc {
	width: 120px;
	height: 44px;
	background: #0096FF;
	border: none;
	border-radius: 6px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}

// 电商编号
.dianshangO{
	// width: 350px;
	padding: 16px;
	border-radius: 12px;
	border: 1px solid #EDEDED;
	background: #FAFAFA;
	margin-right: 12px;
	margin-bottom: 24px;
	.t1{
		font-size: 14px;
		color: #333;
	}
	.el-image{
		width: 18px;
		height: 18px;
		margin-left: 6px;
	}
}

// 物流列表
.wuliuList{
	margin-bottom: 12px;
	div{color: #333;}
	.wlItem{
		width: 350px;
		padding: 16px;
		border-radius: 12px;
		border: 1px solid #EDEDED;
		background: #FAFAFA;
		margin-right: 12px;
		margin-bottom: 12px;
		.t1{
			div{
				font-size: 14px;
			}
			.look{
				color: #0096FF;
				font-size: 14px;
				cursor: pointer;
			}
		}
		.t2{
			font-size: 14px;
			margin-top: 12px;
			.el-image{
				width: 18px;
				height: 18px;
				margin-left: 6px;
			}
		}
	}
}
/* ===================================================================
   物流弹出框
   =================================================================== */
.popup-header {
	height: 69px;
	display: flex;
	align-items: center;
	background: #F8f8f8;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 30px;
}
.popup-title {
	font-size: 18px;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
}
.submitPopup{
	background: #fff;
	border-radius: 32px;
	padding-bottom: 32px;
	.wlsn{
		padding: 0 32px;
		padding-bottom: 20px;
		padding-top: 8px;
		.t1{
			font-size: 16px;
			span{
				color: #0096FF;
				padding-left: 16px;
				cursor: pointer;
			}
		}
	}
	.wuliuListHb{
		margin: auto;
		background: #fff;
		padding: 12px 32px;
		padding-left: 40px;
		border-radius: 24px;
		max-height: 300px;
		overflow-y: scroll;
		.item{
			padding-left: 30px;
			border-left: 2px solid #EDEDED;
			position: relative;
			padding-bottom: 60px;
			&:last-child{
				border: none;
				padding-bottom: 0;
			}
			&:first-child{
				&::after{
					background: #0096FF;
				}
				.txtbox{
					.t1{
						color: #0096FF;
					}
					.t2{
						color: #333;
					}
				}
			}
			&::after{
				content: '';
				position: absolute;
				border-radius: 50%;
				width: 10px;
				height: 10px;
				left: -7.5px;
				top: 0;
				background: #EDEDED;
				border: 3px solid #fff;
			}
			.txtbox{
				transform: translateY(-6px);
				span{
					display: block;
				}
				.t1{
					font-size: 14px;
					color: #9C9C9C;
				}
				.t2{
					font-size: 12px;
					color: #9C9C9C;
					margin-top: 8px;
				}
			}
		}
	}
}
.popup-footer {
	display: flex;
	justify-content: flex-end;
	padding: 0;
	background: #fff;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}
.popup-btn {
	width: 120px;
	height: 44px;
	border-radius: 6px;
	text-align: center;
	line-height: 44px;
	font-size: 16px;
	cursor: pointer;
	margin-left: 14px;
	transition: background 0.3s;
}
.btn-cancel {
	background: #E9F6FF;
	color: #0096FF;
}
.btn-confirm {
	background: #0096FF;
	color: #fff;
}
.btn-confirm:hover {
	background: #33ABFF;
}
</style>
